﻿import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import {clearFix} from '../Style/cssHelpers';

export default class StepSection extends React.Component {
    constructor(props) {
        super(props);
    }

    static get propTypes() {
        return {
            sectionId: PropTypes.number.isRequired
        }
    }

    willLeave = () => ({
        opacity: spring(0, {stiffness: 390, damping: 31}),
        translateLeft: spring(-1000, {stiffness: 390, damping: 31}),
        maxHeight: spring(0, {stiffness: 390, damping: 31}),
        position: 0
    })

    willEnter = () => ({
        opacity: 0,
        translateLeft: 1000,
        maxHeight: 3000,
        position: 1
    })

    getStyles = () => ({
        opacity: spring(1),
        translateLeft: spring(0),
        maxHeight: spring(3000), 
        position: spring(1)
    })

    getInterpolatedStyles = (style) => ({
        opacity: style.opacity,
        // disable transform when done, otherwise interferes with children positioned as fixed, see: 
        // https://stackoverflow.com/questions/25824749/why-webkit-transform-translate3d0-0-0-messes-up-with-fixed-childs
        transform: style.translateLeft === 0 ? 'none' : `translateX(${style.translateLeft}vw)`, 
        zIndex: '99',
        maxHeight: `${style.maxHeight}vh`,
        position: `${style.position > 0 ? 'relative' : 'absolute'}` // HACK: fixes parent wrapper height resize issues
    })
    
    render() {
        return (
            <AnimatePresence>
                {this.props.children.length ? (
                    <motion.div
                        key={`${this.props.sectionId}--key`}
                        initial={{ opacity: 0, x: 1000, maxHeight: 3000, position: 'absolute' }}
                        animate={{ opacity: 1, x: 0, maxHeight: 3000, position: 'relative' }}
                        exit={{ opacity: 0, x: -1000, maxHeight: 0, position: 'absolute' }}
                        transition={{ type: "spring", stiffness: 390, damping: 31 }}
                    >
                        <SectionWrapper>
                            {this.props.children}
                        </SectionWrapper>
                    </motion.div>
                ) : null}
            </AnimatePresence>
        );        
    }
}

const SectionWrapper = styled.div`
    position: relative;
    float: left; 
    width: 100%; 

    ${clearFix()}; 
`;